'use strict';

var OVERLAY_CLASS = 'quantum-dropdown-overlay';
var OVERLAY_MAX_HEIGHT = 240;
var OVERLAY_MIN_HEIGHT = 120;

/**
 * Inside the scrollable quantum flavour list (SFCC-3176) an opened option list would be
 * clipped by the box, so it is shown as a fixed overlay anchored to its picker instead.
 * It always opens downwards, shrinking to the room left below the picker (never under
 * OVERLAY_MIN_HEIGHT); the options scroll inside it.
 * @param {jQuery} $dropdown - the [data-dropdown] element that was opened
 */
function showAsOverlay($dropdown) {
    var $content = $dropdown.find('.dropdown-content');
    var dropdownRect = $dropdown[0].getBoundingClientRect();
    var headerRect = $dropdown.find('.dropdown-header')[0].getBoundingClientRect();
    var spaceBelow = window.innerHeight - headerRect.bottom;
    var maxHeight = Math.max(Math.min(spaceBelow - 8, OVERLAY_MAX_HEIGHT), OVERLAY_MIN_HEIGHT);

    $content.addClass(OVERLAY_CLASS).css({
        position: 'fixed',
        left: dropdownRect.left,
        width: dropdownRect.width,
        maxHeight: maxHeight,
        top: headerRect.bottom
    });
}

// Set when revealInList scrolls the list itself, so that scroll doesn't close the overlay.
var ignoreNextListScroll = false;

/**
 * Scrolls the flavour list so the picker being opened is fully inside the box. A picker
 * that is only half visible would otherwise get its options anchored below the box,
 * on top of the hint and summary under the list.
 * @param {jQuery} $dropdown - the [data-dropdown] element being opened
 */
function revealInList($dropdown) {
    var $list = $dropdown.closest('.quantum-flavour-list');
    var listRect = $list[0].getBoundingClientRect();
    var headerRect = $dropdown.find('.dropdown-header')[0].getBoundingClientRect();
    var delta = 0;

    if (headerRect.top < listRect.top) {
        delta = headerRect.top - listRect.top;
    } else if (headerRect.bottom > listRect.bottom) {
        delta = headerRect.bottom - listRect.bottom;
    }

    if (delta) {
        var before = $list.scrollTop();
        $list.scrollTop(before + delta);
        ignoreNextListScroll = $list.scrollTop() !== before;
    }
}

/**
 * Closes any open quantum flavour picker overlay - its fixed position no longer matches
 * the picker once the page or the list scrolls, or the window is resized.
 */
function closeOverlays() {
    $('.' + OVERLAY_CLASS).each(function () {
        $(this).removeClass(OVERLAY_CLASS).removeAttr('style')
            .closest('[data-dropdown]').removeClass('active');
    });
}

module.exports = function () {
    $('body').on('click', '[data-dropdown-header]', function (e) {
        e.preventDefault();

        var $currentDropdown = $(this).closest('[data-dropdown]');
        var dropDownFields = $('[data-dropdown-header]');

        // Iterate through each dropdown, but skip the current one
        // This is a case where there are multiple dropdowns on a page
        dropDownFields.each(function () {
            var $dropdown = $(this).closest('[data-dropdown]');
            if ($dropdown[0] !== $currentDropdown[0]) {
                $dropdown.removeClass('active');
            }
        });

        // Toggle the active class on the current dropdown
        $currentDropdown.toggleClass('active');

        if ($currentDropdown.closest('.quantum-flavour-list').length) {
            if ($currentDropdown.hasClass('active')) {
                revealInList($currentDropdown);
                showAsOverlay($currentDropdown);
            } else {
                closeOverlays();
            }
        }

        e.stopPropagation();
    });

    // Capture phase, because scroll events on the flavour list don't bubble. Scrolling inside
    // the open option list itself is ignored.
    document.addEventListener('scroll', function (e) {
        if (ignoreNextListScroll && $(e.target).is('.quantum-flavour-list')) {
            ignoreNextListScroll = false;
            return;
        }

        if ($('.' + OVERLAY_CLASS).length && !$(e.target).closest('.' + OVERLAY_CLASS).length) {
            closeOverlays();
        }
    }, true);

    $(window).on('resize', closeOverlays);

    $(document).on('click', function (e) {
        if ($(e.target).is('[data-dropdown]') === false) {
            $('[data-dropdown]').removeClass('active');
            closeOverlays();
        }
    });
};
